module.exports = __webpack_public_path__ + "img/feature_oxford.5f993ad0.png";